import { render, staticRenderFns } from "./QuestionImage.vue?vue&type=template&id=63aab1a3&"
import script from "./QuestionImage.vue?vue&type=script&lang=ts&"
export * from "./QuestionImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports